import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {withdrawverifys,withdrawverify,withdrawApprove,withdrawDisapprove} = api

/**
 * 查找列表
 */
export async function findWithdrawverifys(params) {
    return request({url:withdrawverifys, method: 'get', data: params,})
}
/**
 * 查找详情
 */
export async function findWithdrawverify(params) {
    return request({url:withdrawverify, method: 'get', data: params,})
}
/**
 * 审核通过
 */
export async function approveWithdraw(params) {
    return request({url:withdrawApprove, method: 'post', data: params,})
}
/**
 * 审核拒绝
 */
export async function disapproveWithdraw(params) {
    return request({url:withdrawDisapprove, method: 'post', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/withdrawVerify.js